import { ELoggedInUserType, IPayrollLockedData, IPayrollStatusDocument } from "../models"
import AccountStore from "../stores/AccountStore"
import AuthenticationStore from "../stores/AuthenticationStore"
import * as permissionHelper from "./permissionHelper"

export function isLocked(payrollStatusDocs: IPayrollStatusDocument[], employeeId: string, loggedInUserType: ELoggedInUserType): boolean {
    if (!payrollStatusDocs)
        return false

    return payrollStatusDocs.find(payrollStatusDoc => {
        if (!payrollStatusDoc) return false
        if (payrollStatusDoc.ClosedData && payrollStatusDoc.ClosedData.IsClosed) {
            return true
        }
        else {
            if (loggedInUserType === ELoggedInUserType.Employee) {
                if (individualLocked(payrollStatusDoc.LockedData, employeeId)) {
                    return true
                }
                else {
                    if (AccountStore.getEnableEmployeeLock()) {
                        return payrollStatusDoc.EmpLockedData && payrollStatusDoc.EmpLockedData.IsLocked ? true : false
                    }
                    else {
                        return false
                    }
                }
            }
            else {
                const editPayrollAfterLock = AccountStore.getEnableSupervisorLock() && permissionHelper.hasPermission(AuthenticationStore.Permissions.Payroll.EditPayrollAfterLock)
                if (editPayrollAfterLock) {
                    return false
                }
                else {
                    return individualLocked(payrollStatusDoc.LockedData, employeeId)
                }
            }
        }
    }) ?
        true : false
}

function individualLocked(lockedData: IPayrollLockedData, employeeId: string) {
    if (!lockedData) {
        return false
    }
    if (lockedData.IsLocked) {
        return true
    }
    return lockedData.LockedObjData && lockedData.LockedObjData.find(i => i.LockedObjId === employeeId) ? true : false
}